import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { initialForm } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import SelectPaymentMode from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/SelectPaymentMode";
import { paymentModeMapping } from "../constant";
import { getPaymentModeName } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
const EditPaymentModeModal = ({
  contextValue,
  isOpen,
  setIsOpen,
  rowId,
  oldPaymentMode,
}) => {
  const [subHeading, setSubHeading] = useState("");
  const {
    setPaymentModeForm,
    setBalanceMode,
    paymentModeForm,
    currentPaymentMode,
  } = contextValue;
  const handleClose = (isSave = false, isReset = false) => {
    const amount = paymentModeForm?.paidAmount;
    !isReset && setIsOpen(false);
    setPaymentModeForm({ ...initialForm, paidAmount: amount });
    isSave && setBalanceMode(false);
  };

  useEffect(() => {
    const newPaymentMode = paymentModeMapping[currentPaymentMode];
    const newPaymentModeName =
      getPaymentModeName(newPaymentMode)?.toLowerCase();
    const oldPaymentModeName =
      getPaymentModeName(oldPaymentMode)?.toLowerCase();
    const data =
      oldPaymentMode == newPaymentMode
        ? "You can edit the current details or select a new payment mode"
        : `You are changing from ${oldPaymentModeName} to ${newPaymentModeName}`;
    setSubHeading(data);
  }, [oldPaymentMode, currentPaymentMode]);

  return (
    <Modal isOpen={isOpen} style={{ width: "67%" }} size="xl" centered={true}>
      <ModalBody className="p-4">
        {currentPaymentMode!='default'&&<SelectPaymentMode
          subHeading={subHeading}
          contextValue={contextValue}
          isReceiptEdit={isOpen}
          isReceipt={isOpen}
          handleClose={handleClose}
          rowId={rowId}
          oldPaymentMode={oldPaymentMode}
        />}
      </ModalBody>
    </Modal>
  );
};
export default EditPaymentModeModal;
